import { render, staticRenderFns } from "./UpperFooter.vue?vue&type=template&id=27f6241e"
import script from "./UpperFooter.vue?vue&type=script&lang=js"
export * from "./UpperFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports